/*
 * port-originel — scripts maison, hors bundle Maestrooo (ne pas mettre ce code dans theme.js).
 */

/**
 * <carousel-autoplay aria-controls="carousel-id" interval="5">
 *
 * Fait défiler automatiquement un <scroll-carousel> du thème (utilisé par le bloc "Offres" de la fiche produit
 * pour la réassurance). Revient au premier élément après le dernier. Se met en pause au survol / focus, s'arrête
 * définitivement dès que le visiteur touche le carrousel, et ne démarre pas si l'utilisateur a demandé à réduire
 * les animations.
 */
class CarouselAutoplay extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.carousel = document.getElementById(this.getAttribute('aria-controls'));

    if (!this.carousel) {
      return;
    }

    this.abortController = new AbortController();
    this.paused = false;

    const zone = this.carousel.parentElement;
    const options = { signal: this.abortController.signal };

    zone.addEventListener('pointerenter', () => (this.paused = true), options);
    zone.addEventListener('pointerleave', () => (this.paused = false), options);
    zone.addEventListener('focusin', () => (this.paused = true), options);
    zone.addEventListener('focusout', () => (this.paused = false), options);
    zone.addEventListener('pointerdown', () => this.stop(), options);

    customElements.whenDefined('scroll-carousel').then(() => {
      if (this.abortController.signal.aborted) {
        return;
      }

      const interval = Math.max(2, parseFloat(this.getAttribute('interval')) || 5) * 1000;
      this.timer = setInterval(() => this.tick(), interval);
    });
  }

  disconnectedCallback() {
    this.stop();
  }

  tick() {
    const cells = this.carousel.cells;

    if (this.paused || document.hidden || !cells || cells.length < 2) {
      return;
    }

    this.carousel.select((this.carousel.selectedIndex + 1) % cells.length);
  }

  stop() {
    clearInterval(this.timer);
    this.abortController?.abort();
  }
}

if (!window.customElements.get('carousel-autoplay')) {
  window.customElements.define('carousel-autoplay', CarouselAutoplay);
}
